<template>
  <div class="home">
    <img
      style="width:1px; height:1px;"
      :src="'https://servedby.flashtalking.com/imp/2/112659;4077673;201;pixel;Forbes;PSGCDDSFLATRNNETNTVForbesForbesForbesmicrositemltnative/?cachebuster='+timecurr()"
    />
    <carousel
      :scrollPerPage="false"
      :mouse-drag="true"
      :paginationEnabled="true"
      :autoplay="true"
      :autoplayHoverPause="false"
      :navigation-enabled="true"
      :navigation-next-label="nextLabel"
      :navigation-prev-label="prevLabel"
      :loop="true"
      :paginationSize="10"
      :perPage="1"
      :speed="1"
      :autoplayTimeout="15000"
      :adjustableHeight="false"
      :transitionend="slideranim()"
      v-model="currentIndex"
    >
      <slide
        :class="'person'"
        data-index="0"
        data-name="D. Tóth Kriszta"
        @slideclick="slidenavigation"
      >
        <div class="face">
          <img
            src="../assets/img/D.Toth-Kriszta-home.png"
            alt="D. Tóth Kriszta"
          >
        </div>
        <div class="name">
          D. Tóth Kriszta
        </div>
        <div class="titlebig">
          A tudatos autóhasználatról
        </div>
        <div class="cols">
          <div class="col">
            Nagyon bízom a gyerekeink generációjában. Ők egészen máshogy nyúlnak a problémákhoz,
            mint mi. És jó lenne, ha ők már nem is adnának lehetőséget olyan vezetőknek,
            vagy politikusoknak, akiknek ez a probléma nem fontos.
          </div>
          <div class="col">
            <img
              class="benzlogo"
              src="../assets/img/mercedes-footer.svg"
              alt="Mercedes Benz"
            >
          </div>
        </div>
      </slide>
      <slide
        :class="'person'"
        data-index="1"
        data-name="Győrfi Pál"
        @slideclick="slidenavigation"
      >
        <div class="face">
          <img
            src="../assets/img/Gyorfi-Pal-home.png"
            alt="Győrfi Pál"
          >
        </div>
        <div class="name">
          Győrfi Pál
        </div>
        <div class="titlebig">
          Az innováció iránti vonzalomról
        </div>
        <div class="cols">
          <div class="col">
            Az elektromos autóval teszek valamit az élhető jövőért, vezetés közben pedig derűsebb,
            nyugodtabb vagyok. Nehéz megmagyarázni, de így csökken bennem a közlekedési stressz,
            és a fejlett technológia hatására egy ilyen autóban a vezető is valahogy tudatosabbá,
            precízebbé válik.
          </div>
          <div class="col">
            <img
              class="benzlogo"
              src="../assets/img/mercedes-footer.svg"
              alt="Mercedes Benz"
            >
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'home',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      currentIndex: 0,
      nextLabel: "<img src='./right-single.svg' />",
      prevLabel: "<img src='./left-single.svg' />",
    };
  },
  methods: {
    slideranim() {
      setTimeout(() => {
        const dots = document.querySelectorAll('.VueCarousel-dot');
        const slides = document.querySelectorAll('.VueCarousel-slide');
        for (let index = 0; index < dots.length; index += 1) {
          const element = dots[index];
          if (element.classList.contains('VueCarousel-dot--active')) {
            slides[index].classList.add('anim');
          } else {
            slides[index].classList.remove('anim');
          }
        }
      }, 500);
    },
    slidenavigation(dataset) {
      if (dataset.index === '0') {
        this.$router.push('a-tudatos-autohasznalatrol');
      }
      if (dataset.index === '1') {
        this.$router.push('az-innovacio-iranti-vonzalomrol');
      }
    },
    timecurr() {
      const time = new Date();
      return `${time.getFullYear()}${time.getMonth()}${time.getDate()}${time.getHours()}${time.getMinutes()}${time.getSeconds()}`;
    },
  },
  mounted() {
  },
};
</script>
<style scoped lang="css">
.home {
  padding-top: 35px;
}
.person {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 70px 1fr 1fr 70px;
  -ms-grid-columns: 70px 1fr 1fr 70px;
  grid-template-rows: auto auto auto auto;
  -ms-grid-rows: auto auto auto auto;
  cursor: pointer;
  overflow: hidden;
}
.face {
  grid-column: 1/3;
  -ms-grid-column: 1;
  -ms-grid-column-span: 2;
  grid-row: 1/5;
  -ms-grid-row: 1;
  -ms-grid-row-span: 4;
}
.face img {
  width: 100%;
  margin-left: 20px;
  transform: translateX(-100%);
  transition: all 2s;
}
.anim .face img {
  transform: translateX(0%);
}
.name {
  font-size: 22px;
  text-transform: uppercase;
  margin-bottom: 30px;
  grid-column: 3/4;
  -ms-grid-column: 3;
  grid-row: 1/2;
  -ms-grid-row: 1;
}
.titlebig {
  font-size: 82px;
  font-family: "Old Standard TT", serif;
  font-weight: normal;
  line-height: 1;
  margin-bottom: 20px;
  grid-column: 3/4;
  -ms-grid-column: 3;
  grid-row: 2/3;
  -ms-grid-row: 2;
}
.cols {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  grid-column: 3/4;
  -ms-grid-column: 3;
  grid-row: 3/4;
  -ms-grid-row: 3;
}
.col:nth-child(1) {
  width: 100%;
  font-size: 16px;
  text-align: justify;
  margin: 0px;
  line-height: 1.5;
}
.benzlogo {
  height: 60px;
  margin-top: 60px;
  margin-bottom: 20px;
  grid-column: 3/4;
  -ms-grid-column: 4;
  grid-row: 4/5;
  -ms-grid-row: 4;
}
.col:nth-child(2) {
  width: 100%;
  text-align: right;
}
.name,
.titlebig,
.cols {
  opacity: 0;
  transition: all 3s;
}
.anim .name,
.anim .titlebig,
.anim .cols {
  opacity: 1;
}

@media screen and (max-width: 767px) {
  .home {
    padding-top: 15px;
  }
  .person {
    grid-template-columns: 40px 1fr 1fr 40px;
    -ms-grid-columns: 40px 1fr 1fr 40px;
  }
  .face {
    grid-row: 1/3;
    -ms-grid-row: 1;
    -ms-grid-row-span: 2;
  }
  .name {
    margin: 0px;
  }
  .titlebig {
    font-size: 45px;
  }
  .cols,
  .benzlogo {
    grid-column: 2/4;
    -ms-grid-column: 2;
    -ms-grid-column-span: 2;
  }
  .cols {
    margin-top: 20px;
  }
  .benzlogo {
    margin-top: 20px;
  }
}
@media screen and (max-width: 540px) {
  .col {
    width: 100%;
    margin-bottom: 15px;
  }
  .benzlogo {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .face {
    grid-row: 1/2;
    -ms-grid-row: 1;
    -ms-grid-row-span: 1;
  }
  .titlebig {
    grid-column: 2/4;
    -ms-grid-column: 2;
    -ms-grid-column-span: 2;
    margin: 20px 0;
  }
  .name {
    align-self: center;
    text-align: right;
  }
  .titlebig {
    font-size: 34px;
  }
  .person {
    grid-template-columns: 25px 1fr 1fr 25px;
    -ms-grid-columns: 25px 1fr 1fr 25px;
  }
}
</style>
<style>
.VueCarousel-pagination {
  position: absolute;
  bottom: 0px;
  left: 0px;
}
.VueCarousel-dot.VueCarousel-dot--active {
  background-color: #00a3f8 !important;
}
.VueCarousel-dot:focus {
  outline: none !important;
}
.VueCarousel-navigation {
  position: absolute;
  top: calc(50% - 15px);
  left: 0;
  width: 100%;
}
.VueCarousel-navigation-prev,
.VueCarousel-navigation-next {
  transform: none !important;
  padding: 0px !important;
  margin: 0px !important;
}
.VueCarousel-navigation-prev {
  left: 15px !important;
}
.VueCarousel-navigation-next {
  right: 15px !important;
}
.VueCarousel-navigation-prev img,
.VueCarousel-navigation-next img {
  height: 30px;
}
.VueCarousel-navigation-button {
  top: 0% !important;
}
.VueCarousel-navigation-button:focus,
.VueCarousel-navigation-button:active {
  outline: none !important;
}
@media screen and (max-width: 767px) {
  .VueCarousel-navigation-prev img,
  .VueCarousel-navigation-next img {
    height: 25px;
  }
  .VueCarousel-navigation {
    top: calc(25% - 15px);
  }
  .VueCarousel-navigation-prev {
    left: 10px !important;
  }
  .VueCarousel-navigation-next {
    right: 10px !important;
  }
}
</style>
